// Banner de error consistente para queries. Renderiza null si no hay error.
// Evita que una query fallida (red/RLS) deje la pantalla vacía sin avisar.
export function QueryError({ error }: { error: unknown }) {
  if (!error) return null;
  const msg = error instanceof Error ? error.message : String(error);
  return (
    <div className="mb-4 rounded-lg bg-red-50 px-4 py-2 text-sm text-red-700">
      No se pudo cargar la información: {msg}
    </div>
  );
}
